module.exports = __webpack_public_path__ + "779a780bd10a21f375734e9612e720ec.pdf";